// utils/refreshAccessToken.ts
import { getBaseApi } from './runtimeOrg';

export const refreshAccessToken = async (): Promise<string> => {
  const base = getBaseApi(); // absolute, no trailing slash
  const refreshToken = localStorage.getItem('refreshToken');

  if (!refreshToken) throw new Error('No refresh token available');
  if (!base) throw new Error('API base URL not configured');

  const res = await fetch(`${base}/api/v1/token/refresh/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh: refreshToken }),
  });

  if (!res.ok) throw new Error('Failed to refresh access token');

  const data = await res.json();
  localStorage.setItem('accessToken', data.access);
  if (data.refresh) localStorage.setItem('refreshToken', data.refresh);
  return data.access;
};
